export interface ServiceItem {
  id: string;
  anchor: string;
  icon: string;
  title: string;
  tagline: string;
  description: string;
  details: { name: string; desc: string }[];
}

export const services: ServiceItem[] = [
  {
    id: "production",
    anchor: "production",
    icon: "ri-film-line",
    title: "影视制作",
    tagline: "从创意到成片的全流程影像制作",
    description:
      "芒果传媒影视制作板块覆盖电影、剧集、网络电影等多元形态，具备从剧本孵化、制片管理到拍摄、后期制作与交付的完整能力，累计完成数百部作品的制作与出品。",
    details: [
      { name: "创意发想", desc: "从题材策划、故事大纲到分集剧本，与编剧团队协同打磨原创内容。" },
      { name: "制作流程管理", desc: "统筹预算、排期、场地与人员，保障项目在既定周期内高质量交付。" },
      { name: "导演与摄影", desc: "组建专业导演与摄影团队，以电影级视听标准完成现场拍摄。" },
      { name: "后期与视效", desc: "剪辑、调色、混音、特效一体化后期，打造细腻的画面质感。" },
    ],
  },
  {
    id: "programming",
    anchor: "programming",
    icon: "ri-video-line",
    title: "节目策划",
    tagline: "为平台与品牌打造有记忆点的综艺内容",
    description:
      "节目策划板块专注于综艺、纪实、访谈、直播等节目的模式研发与内容制作。我们擅长从受众洞察出发，设计兼具观赏性与商业价值的节目模式，并完成从策划到落地的全流程执行。",
    details: [
      { name: "模式研发", desc: "基于市场洞察与受众研究，进行节目模式创新与版权开发。" },
      { name: "内容编排", desc: "设计节目结构、环节与叙事节奏，保证内容张弛有度。" },
      { name: "现场执行", desc: "统筹录制现场、舞台设计与多机位导播，呈现最佳舞台效果。" },
      { name: "多平台适配", desc: "针对电视、长视频、短视频等不同渠道进行内容二次创作。" },
    ],
  },
  {
    id: "distribution",
    anchor: "distribution",
    icon: "ri-share-forward-line",
    title: "内容发行",
    tagline: "让好内容触达更广阔的观众",
    description:
      "内容发行板块负责影视与节目内容的分发与运营，覆盖主流长视频平台、电视台、海外渠道及新媒体矩阵，通过精准的发行策略与运营手段，帮助内容实现传播价值与商业价值的最大化。",
    details: [
      { name: "渠道发行", desc: "对接国内外主流平台与电视台，制定差异化发行方案。" },
      { name: "海外传播", desc: "推动优质内容出海，参与国际展会与海外版权合作。" },
      { name: "运营推广", desc: "结合话题运营与新媒体传播，提升内容的曝光与口碑。" },
      { name: "版权管理", desc: "完善内容版权登记与管理体系，保障各方权益。" },
    ],
  },
];